module.exports = __webpack_public_path__ + "39b11f10fbbe3142859230c9c4d2671c.png";